import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div`
  background: #ffffff;
  width: 90%;
  max-width: 900px;
  max-height: 90vh;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

export const ModalHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #eee;

  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
    color: #444;
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const ModalBody = styled.div`
  padding: 24px;
  overflow-y: auto;
  flex: 1;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  span {
    font-size: 12px;
    color: #6b7280;
    font-weight: 600;
  }

  strong {
    color: #111827;
    font-size: 14px;
    font-weight: 800;
    word-break: break-word;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: #eee;
  margin: 16px 0;
`;

export const FilesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FileItem = styled.div`
  background: #f9f9f9;
  padding: 12px 16px;
  border-radius: 6px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FileInfo = styled.div`
  display: flex;
  flex-direction: column;

  strong {
    color: #333;
  }

  span {
    font-size: 12px;
    color: #888;
  }
`;

export const FileActions = styled.div`
  display: flex;
  gap: 16px;

  svg {
    cursor: pointer;
    color: #6ea5ff;
  }

  svg:last-child {
    color: #e74c3c;
  }
`;

export const PreviewContainer = styled.div`
  margin-top: 24px;
  border-top: 1px solid #eee;
  padding-top: 16px;

  iframe {
    width: 100%;
    height: 500px;
    border: none;
  }

  img {
    max-width: 100%;
    max-height: 500px;
    display: block;
    margin: 0 auto;
  }
`;

export const LinkActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const LinkButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  height: 40px;
  padding: 0 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;

  background: #6ea5ff;
  color: #fff;
  font-weight: 600;

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const LinkBox = styled.div`
  flex: 1;
  min-width: 260px;
  max-width: 100%;
  height: 40px;

  display: flex;
  align-items: center;

  padding: 0 12px;
  border-radius: 6px;
  border: 1px solid #e5e5e5;
  background: #fafafa;

  color: #444;
  font-size: 14px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  height: 40px;
  padding: 0 14px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  cursor: pointer;

  background: #fff;
  color: #444;
  font-weight: 600;
`;

export const EmptyState = styled.div`
  margin-top: 12px;
  padding: 14px 16px;
  border-radius: 6px;
  background: #f9f9f9;
  color: #666;

  p {
    margin: 0;
    & + p {
      margin-top: 6px;
    }
  }
`;
